import { Injectable, Injector} from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { map } from "rxjs/operators";
import { Observable } from 'rxjs';
import { SyncService } from "./sync.service";
import { IManagableObject } from "../system/admin-panel/IManagableObject";

export class ServiceTaskModel implements IManagableObject {
  Id: number = 0;
  ObjectId: number = 0;
  ObjectName: string = "";

  IsChecked: boolean = false;

  Name: string = "";
  Comment: string = "";

  TimeEnabled: boolean = false;
  Time: number = new Date().getTime();
  TimePeriod: number = 0;

  OdometrEnabled: boolean = false;
  Odometr: number = 0;
  OdometrPeriod: number = 0;

  WorkTimeEnabled: boolean = false;
  WorkTime: number = 0;
  WorkTimePeriod: number = 0;

  init(data?: any) {
    if (data) {
      this.Id = data["id"];
      this.ObjectId = data["objectId"];
      this.Name = data["name"];
      this.Comment = data["comment"];
      this.Time = data["time"];
      this.TimePeriod = data["timePeriod"];
      this.Odometr = data["odometr"];
      this.OdometrPeriod = data["odometrPeriod"];
      this.WorkTime = data["workTime"];
      this.WorkTimePeriod = data["workTimePeriod"];

      this.TimeEnabled = this.Time > 0;
      this.OdometrEnabled = this.Odometr > 0;
      this.WorkTimeEnabled = this.WorkTime > 0;
    }
  }

  static fromJS(data: any): ServiceTaskModel {
    data = typeof data === 'object' ? data : {};
    let result = new ServiceTaskModel();
    result.init(data);
    return result;
  }
}

@Injectable()
export class ServiceTaskService
{
  protected syncService: SyncService;
  protected client: HttpClient;

  constructor(protected injector: Injector)
  {
    this.syncService = injector.get(SyncService);
    this.client = injector.get(HttpClient);
  }

  public getAll(): Observable<ServiceTaskModel[]>
  {
    return this.client.get<any>("/ctrl/servicetask").pipe(map(values => {
      let result = [];
      if (values && values.constructor === Array)
        for (let item of values)
          result.push(ServiceTaskModel.fromJS(item));
      return result;
    }));
  }

  public get(id: number)
  {
    return this.client.get<any>("/ctrl/servicetask/"+id).pipe(map(values => {
        return ServiceTaskModel.fromJS(values);
    }));
  }

  public update(model: ServiceTaskModel) {
    if (!model.OdometrEnabled)
      model.Odometr = 0;
    if (!model.TimeEnabled)
      model.Time = 0;
    if (!model.WorkTimeEnabled)
      model.WorkTime = 0;

    return this.client.put("/ctrl/servicetask", model).pipe(map(values => {
      this.syncService.NotifyEntityChanged("ServiceTask", model.Id);
      return values;
    }));
  }

  public delete(id: number)
  {
    return this.client.delete("/ctrl/servicetask/" + id).pipe(map(values => {
      this.syncService.NotifyEntityChanged("ServiceTask", id);
      return values;
    }));
  }
}
